import { useEffect, useState } from 'react'
import { ViewOnlyPrescription } from '../MyLiveSessions'
import {
  getDataWithoutParams,
  getUserPrescriptionOfEvent,
} from 'src/consumer/services/featureServices'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'
import { useParams } from 'react-router-dom'
import { LoadingSpinner } from '../Loaders'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { ClubbedAuthModal } from '../SignIn/ClubbedAuthComponents'
import { isTokenInvalidOrAbsent } from 'src/views/pages/login/ProtectedRoute'
import PublicAppHeader from '../PublicAppHeader'
import { PrescriptionIndividualPageParent } from 'src/clinic/components/ClinicManageBookingsPage/ClinicManageBookingsPageStyles'
import { PMPButton } from 'src/mentor/components/PrescriptionMakingPage/PrescriptionMakingPageStyles'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import { APP_CONSTANTS } from 'src/consumer/constants'

export default function MyDedicatedPrescriptionPage() {
  const { eventId } = useParams()

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [prescriptionData, setPrescriptionData] = useState(null)
  const [bookedEventFinalData, setBookedEventFinalData] = useState(null)
  const [allEmrSections, setAllEmrSections] = useState()

  async function getPrescriptionOfEvent() {
    setLoading(true)
    setError(false)

    const bookedEventDetailResponse = await getDataWithoutParams(
      `/api/secure/user/booked-slot/details?eventId=${eventId}&send-auxiliary-data=true`,
    )
    if (
      bookedEventDetailResponse?.status === 200 &&
      isCommonResponseSuccessful(bookedEventDetailResponse?.data?.code) &&
      Object.keys(bookedEventDetailResponse?.data?.data?.bookedEvent)?.length !== 0
    ) {
      const beData = bookedEventDetailResponse?.data?.data?.bookedEvent
      setBookedEventFinalData(bookedEventDetailResponse?.data?.data?.bookedEvent)

      if (beData?.eventType === 'consultation') {
        const response = await getUserPrescriptionOfEvent(eventId)
        if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
          setPrescriptionData(response?.data?.data?.metaPrescription)
          setAllEmrSections(response?.data?.data?.allEmrSections)
          setError(false)
          setLoading(false)
          return
        }
      }
    }

    setError(true)
    setLoading(false)
  }

  useEffect(() => {
    getPrescriptionOfEvent()
  }, [])

  const pageTitle = 'Download your prescription | AUMHUM'
  const pageDescription = 'Sign in and download your prescription for the session'

  if (isTokenInvalidOrAbsent(localStorage.getItem('token'))) {
    return (
      <div>
        <ClubbedAuthModal
          open={true}
          onClose={() => console.log('can not close this')}
          noCloseButton={true}
          loginVariant={true}
          loginFieldHeading={'Login to view your prescription'}
        />
        <SEOComponent
          title={pageTitle}
          description={pageDescription}
          image={APP_CONSTANTS.APP_LOGO_LINK}
        />
      </div>
    )
  }

  return (
    <div className="bg-white" style={{ minHeight: '100vh' }}>
      {loading ? (
        <LoadingSpinner bgColor="#fff" dark />
      ) : (
        <div>
          {error ? (
            <>
              <PublicAppHeader />
              <SEOComponent
                title={pageTitle}
                description={pageDescription}
                image={APP_CONSTANTS.APP_LOGO_LINK}
              />
              <div
                style={{
                  height: '100%',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <div style={{ maxWidth: '300px', marginTop: '50px' }}>
                  <div>
                    <ErrorOutlineIcon style={{ fontSize: '32px' }} />
                  </div>
                  <div>
                    Error getting this prescription. Please make sure you are signed in with the
                    same email/phone number provided at reception desk. If the problem persists,
                    contact clinic or AUMHUM support.
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div
              style={{
                padding: '20px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                gap: '32px',
              }}
            >
              <PrescriptionIndividualPageParent>
                <div
                  className="hide-on-print"
                  style={{
                    margin: '0 auto 20px',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    maxWidth: '800px',
                  }}
                >
                  <div>Best viewed on web.</div>
                  <PMPButton onClick={() => window.print()}>Print/Save</PMPButton>
                </div>
                <ViewOnlyPrescription prescriptionData={prescriptionData} emrSections={allEmrSections} />
              </PrescriptionIndividualPageParent>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
